<template>
  <div class="product-item">
    <bg-intro :bg="bg" class="bg-wrapper">
      <div class="operate-intro">
        <h2>北斗运营服务平台</h2>
        <p>北斗RNSS | 短报文 | 特色增值北斗业务</p>
        <!-- <div class="btn-wrapper">
          <button class="btn-content">点击视频了解</button>
        </div> -->
      </div>
    </bg-intro>

    <div class="service-intro">
      <h3>北斗运营服务平台</h3>
      <div class="img-wrapper space-between content_wrapper">
        <img src="../../assets/product/fwpt1.webp" alt="服务平台" />
        <img src="../../assets/product/fwpt2.webp" alt="服务平台" />
        <img src="../../assets/product/fwpt3.webp" alt="服务平台" />
      </div>
      <p class="intro content_wrapper">
        磐钴的卫星运营平台基于“卫星通信 + 精准位置信息 +
        互联网大数据”的基础上，即通过北斗及宽带卫星地基等多网的整合与建设，联合移动互联网，构建位置信息服务云平台，实现卫星服务与运营平台以及个人终端相结合，为行业、企业、大众市场提供卫星通信、精准RNSS信息等天地一体化卫星网络通信综合服务。平台在磐钴团队的努力研发下，获得多项特点，包括具回执发送功能，离线信息接收功能；提供SDK接口快速接入,包含平台及卫星应用服务，可衍生符合客户需求的增值服务；实现卫星网络、无线公网、互联网之间的互通；自建通道单元整列，每组发射通道可为用户提供最快0.1秒/条的服务频度，支持多通道并发，突破北斗卫星通信瓶颈。
        磐钴以卫星运营平台为核心，为广大用户提供定制的卫星应用服务方案。按业务功能的具体需求扩展出应用扩展平台，具有“开放性”和“兼容性”的特点，适用面包括政府应用、边境安防、应急救灾、电力数传、户外赛事等领域应用。
      </p>
    </div>

    <div class="analysis">
      <h3>服务优势</h3>
      <div class="analysis-wrapper content_wrapper space-between flex-wrap">
        <div class="item">
          <img src="../../assets/product/fx1.webp" alt="需求分析" />
          <p class="title">提供SDK接口快速接入</p>
          <p class="intro">SDK简易接入服务，实现各种行业的北斗功能业务逻辑判断处理，保证业务效率</p>
        </div>
        <div class="item">
          <img src="../../assets/product/fx2.webp" alt="需求分析" />
          <p class="title">稳定的收发通道</p>
          <p class="intro">
            自建通道阵列，使用UPS不间断电源供电，实现全自动化检测，维护人员7 * 24小时监控与维护，确保通道稳定
          </p>
        </div>
        <div class="item">
          <img src="../../assets/product/fx3.webp" alt="需求分析" />
          <p class="title">稳定的云服务平台</p>
          <p class="intro">
            自建云服务平台，支持历史数据查询、离线数据获取和轨迹回放等功能，有效地解决了北斗通信无法解决的缺陷
          </p>
        </div>
        <div class="item">
          <img src="../../assets/product/fx4.webp" alt="需求分析" />
          <p class="title">北斗转多种通信方式</p>
          <p class="intro">不局限于北斗与北斗间点对点通信，可实现“北斗到手机短信”、“北斗到邮箱”、“北斗间群发”等功能</p>
        </div>
        <div class="item">
          <img src="../../assets/product/fx5.webp" alt="需求分析" />
          <p class="title">安全的数据传输</p>
          <p class="intro">
            重要接口与数据服务区建有安全防火墙，对数据的安全性进行验证，过滤攻击，以确保数据接入的安全
          </p>
        </div>
        <div class="item">
          <img src="../../assets/product/fx6.webp" alt="需求分析" />
          <p class="title">接入的安全</p>
          <p class="intro">持有官方认可的北斗正式运营商授权开发的运营平台</p>
        </div>
      </div>
    </div>

    <div class="push-service">
      <div class="push-content content_wrapper space-between">
        <img src="../../assets/product/ptts.webp" alt="北斗民用智能卡" />
        <div class="intro-content">
          <h3>普通推送/查询服务</h3>
          <div class="intro">
            <p>1、客户在数据中心绑定需要推送/查询服务器的北斗号，并设置推送地址；</p>
            <p>2、终端设备将数据发往地面站接收地址(190***)询客服；</p>
            <p>3、地面站接收到数据后，将消息推送到客户设置的推送地址上；</p>
            <p>4、如果推送的时候客户服务器未能及时处理推送数据，可以使用查询服务查询丢失的数据；</p>
          </div>
        </div>
      </div>

      <div class="push-content content_wrapper space-between mt40">
        <img src="../../assets/product/zxts.webp" alt="北斗民用智能卡" />
        <div class="intro-content">
          <h3>专线推送/查询服务</h3>
          <div class="intro">
            <p>1、客户在数据中心绑定需要推送/查询服务器的北斗号，并设置推送地址；</p>
            <p>2、地面站接收到专线数据后，将消息推送到客户设置的推送地址上；</p>
            <p>3、如果推送的时候客户服务器未能及时处理推送数据，可以使用查询服务查询丢失的数据；</p>
          </div>
        </div>
      </div>
    </div>
    <div class="push-adventage">
      <h3>推送/查询服务优势</h3>
      <div class="intro-content content_wrapper space-between flex-wrap">
        <div class="item">
          <img src="../../assets/product/fwys1.webp" alt="优势" />
          <p>客户不用搭建/维护地面接收站，可以快速使用服务，节省成本</p>
        </div>
        <div class="item">
          <img src="../../assets/product/fwys2.webp" alt="优势" />
          <p>数据通过公网推送，使用Http协议，快速对接，免去硬件对接，免去对北斗协议的处理</p>
        </div>
        <div class="item">
          <img src="../../assets/product/fwys3.webp" alt="优势" />
          <p>地面站的接收成功率高达95%以上，专线数据接收成功率高达99%以上，给数据传输增加一层保障</p>
        </div>
        <div class="item">
          <img src="../../assets/product/fwys4.webp" alt="优势" />
          <p>使用专线北斗号的时候，可以获得回执反馈信息</p>
        </div>
      </div>
    </div>

    <sample></sample>
    <beDevelop></beDevelop>
  </div>
</template>

<script>
import bgIntro from '@/components/common/product/bgIntro.vue';
import beDevelop from '@/components/common/beDevelop.vue';
import sample from '@/components/common/sample.vue';
export default {
  metaInfo: {
    title: '北斗运营服务平台',
    meta: [
      {
        name: 'keywords',
        content: '北斗三号短报文平台,北斗数据运营服务,北斗二号通信平台',
      },
      {
        name: 'description',
        content:
          '磐钴的卫星运营平台基于过北斗及宽带卫星地基等多网的整合与建设，联合移动互联网，构建位置信息服务云平台，实现卫星服务与运营平台以及个人终端相结合，为行业、企业、大众市场提供卫星通信、精准RNSS信息等天地一体化卫星网络通信综合服务。平台在团队的努力研发下，获得多项特点，包括具回执发送功能，离线信息接收功能；提供SDK接口快速接入,包含平台及卫星应用服务。',
      },
    ],
  },
  data() {
    return {
      bg: require('../../assets/product/fwpt-banner.webp'),
    };
  },

  components: {
    bgIntro,
    beDevelop,
    sample,
  },
};
</script>

<style lang="scss" scoped>
.product-item {
  width: 100%;
  .service-intro {
    padding: 70px 0px;
    background: #f6f7f8;
    h3 {
      text-align: center;
      margin-bottom: 60px;
    }
    p {
      margin-top: 48px;
      box-sizing: border-box;
      padding: 0 40px;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      line-height: 30px;
    }
  }
  .analysis {
    padding: 70px 0px;
    background-color: #fff;
    h3 {
      text-align: center;
    }
    .item {
      box-sizing: border-box;
      width: 30%;
      padding: 40px;
      text-align: center;
      p {
        color: #0d0e24;
        line-height: 25px;
      }
      .title {
        margin-top: 30px;
        margin-bottom: 15px;
        font-size: 16px;
        font-weight: 500;
      }
      .intro {
        font-size: 14px;
        font-weight: 400;
      }
    }
  }
  .push-service {
    background: #f6f7f8;
    padding: 70px 0px;
    .push-content {
      background-color: #fff;
      box-sizing: border-box;
      padding: 80px;
      .intro-content {
        .intro {
          margin-top: 30px;
          font-size: 14px;
          font-weight: 400;
          color: #6e6e66;
          line-height: 30px;
        }
      }
    }
  }
  .push-adventage {
    padding: 70px 0px;
    background-color: #fff;
    h3 {
      text-align: center;
      margin-bottom: 60px;
    }
    .intro-content {
      .item {
        box-sizing: border-box;
        width: 23%;
        text-align: center;
        padding: 20px;
        p {
          margin-top: 20px;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          line-height: 30px;
        }
      }
    }
  }
}
</style>